import { Components } from "../../utils/components";
import { BaseSubmittableForm } from "./base-submittable-form";
export class EnquiryForm extends BaseSubmittableForm {
  constructor(element) {
    super(element);
    this.invalidScrolling = false; // Jquery may not work here.
  }

  init() {// Jquery may not work here
  }

  bindFields() {}

  submit() {
    if (this.isSubmitting()) {
      return;
    }

    this.beginSubmitting();
    this.delay(600).then(() => {
      const areas = ["#enquiry-form"];
      this.doSubmit(null, null).then(result => {
        if (result != null) {
          this.endSubmitting();
          window.recaptchaInit();
        }
      });
    });
  }

}
Components.data(EnquiryForm, "enquiryForm");